import AIButton from '@cobliteam/ai/src/ui/AIButton';
import Tooltip from '@cobliteam/ui/components/Tooltip';
import type { IconNames } from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';
import { type RailDensity, railShowsTitle } from '../hooks/use-rail-density';
import { getAnimatedIcon } from './animatedIcons';

interface SidebarRailItemProps {
  title: string;
  icon?: IconNames;
  isActive?: boolean;
  isHovered?: boolean;
  isAI?: boolean;
  density?: RailDensity;
  showTitle?: boolean;
}

// Sem roteamento nem contexto de dashboard: quem envolve é que navega, então dá pra ter story e teste sem provider.
export function SidebarRailItem({ title, icon, isActive = false, isHovered = false, isAI = false, density = 'full', showTitle = true }: SidebarRailItemProps) {
  const withTitle = railShowsTitle(density, showTitle);

  return (
    <>
      {isAI ? (
        // O tooltip próprio do AIButton diz "Perguntar para o Cobli IA"; no rail sem rótulo quem nomeia é o título da rota.
        <Tooltip content={title} asChild position='right' enable={!withTitle} delayDuration={0}>
          <div className='relative size-8'>
            <AIButton isSelected={isActive} showTooltip={false} size='sm' variant={isActive ? 'solid' : 'soft'} />
          </div>
        </Tooltip>
      ) : (
        <Tooltip content={title} asChild position='right' enable={!withTitle} delayDuration={0}>
          <button
            type='button'
            className={cn(
              'flex size-8 cursor-pointer items-center justify-center rounded-lg text-gray-11 group-hover/primary:bg-primary-4 group-hover/primary:text-primary-12',
              isActive && 'bg-primary-12 text-white group-hover/primary:bg-primary-12 group-hover/primary:text-white'
            )}
          >
            {icon && getAnimatedIcon({ icon, isHovered })}
          </button>
        </Tooltip>
      )}
      {withTitle && (
        <div
          className={cn(
            'flex cursor-pointer flex-col items-center justify-center font-medium text-[11px] text-gray-11',
            density === 'compact' && 'leading-3',
            isActive && 'text-primary-12'
          )}
        >
          {title}
        </div>
      )}
    </>
  );
}
